import { render, staticRenderFns } from "./UpsellOptions.vue?vue&type=template&id=f738af1e"
import script from "./UpsellOptions.vue?vue&type=script&lang=js"
export * from "./UpsellOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports